'use client';
// 搜尋頁 - 結果分類按鈕
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SEARCH_TYPE } from '@/common/constant'; // 搜尋分類  (All、遊戲、動漫、小說、二創)

const SearchTabButton = ({ currentType, setCurrentType }) => {
    const { t } = useTranslation();

    return (
        <div className="py-[10px] max-w-full noScrollX bg-white border-t-1 border-black1">
            <div className="w-max flex items-center gap-x-[2px] px-[20px] umd:pr-[15px] usm:pl-0">
                {SEARCH_TYPE.map((tab, i) => (
                    <React.Fragment key={'search' + tab + i}>
                        <button
                            onClick={() => setCurrentType(tab)}
                            className={`px-[20px] py-[11px] text-black9 text-btn1b underline decoration-transparent
                            ${
                                tab === currentType
                                    ? '!text-bou !decoration-bou cursor-default'
                                    : 'hover:decoration-black9 trans hover:text-black9'
                            }`}
                        >
                            {t(tab)}
                        </button>

                        {/* 分隔線 */}
                        {i < SEARCH_TYPE?.length - 1 && (
                            <span className="w-[1px] h-[10px] border-l-1 border-black2" />
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default SearchTabButton;
